import { isExpired } from '@/utils/dateTimeUtils';

export default function useHasExpired(endDate) {
  return isExpired(endDate);
};
